import { Provider, Type } from '@angular/core';
import { DATA_TEST_DIALOG_COMPONENT, DataTestService, DataTestableQuery } from '@y42/data-test';
import { DataTestDialogComponent } from './components/data-test-dialog/data-test-dialog.component';

export interface DataTestServiceDef {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  DataTestService: Type<DataTestService<any>>;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  DataTestParentQuery: Type<DataTestableQuery<any>>;
}

export function provideDataTest(providers: DataTestServiceDef): Provider[] {
  const { DataTestService: dataTestService, DataTestParentQuery: dataTestParentQuery } = providers;
  return [
    {
      provide: DataTestService,
      useExisting: dataTestService,
    },
    {
      provide: DataTestableQuery,
      useExisting: dataTestParentQuery,
    },
    {
      provide: DATA_TEST_DIALOG_COMPONENT,
      useValue: DataTestDialogComponent,
    },
  ];
}
